import { useState } from "react";
import { useQuery, useInfiniteQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

const fetcher = (url) => api.get(url).then((r) => r.data);

export const useCatalog = () => {
  const cats = useQuery({ queryKey: ["categories"], queryFn: () => fetcher("/categories") });
  const locs = useQuery({ queryKey: ["localities"], queryFn: () => fetcher("/localities") });
  const tws = useQuery({ queryKey: ["towns"], queryFn: () => fetcher("/towns") });
  const towns = tws.data || [];
  const categories = cats.data || [];
  const localities = locs.data || [];
  const catById = Object.fromEntries(categories.map((c) => [c.id, c]));
  const locById = Object.fromEntries(localities.map((l) => [l.id, l]));
  return { categories, localities, catById, locById, towns };
};

export const useTown = () => {
  const [town, setTownState] = useState(() => localStorage.getItem("m360_town") || "");
  const setTown = (v) => {
    localStorage.setItem("m360_town", v);
    setTownState(v);
  };
  return [town, setTown];
};

export const useListSub = () => {
  const { data } = useApi("plans", "/plans");
  return data && !data.enabled ? "list_free_sub_free" : "list_free_sub";
};

export const useApi = (key, url, opts = {}) =>
  useQuery({ queryKey: Array.isArray(key) ? key : [key], queryFn: () => fetcher(url), ...opts });

export const usePaged = (key, url, step = 30, opts = {}) => {
  const sep = url.includes("?") ? "&" : "?";
  const q = useInfiniteQuery({
    queryKey: [...key, url],
    queryFn: ({ pageParam }) => fetcher(`${url}${sep}paged=1&limit=${step}&skip=${pageParam}`),
    initialPageParam: 0,
    getNextPageParam: (last, all) => {
      const got = all.reduce((s, p) => s + p.items.length, 0);
      return got < last.total && last.items.length ? got : undefined;
    },
    ...opts,
  });
  return {
    items: q.data?.pages.flatMap((p) => p.items) || [],
    total: q.data?.pages[0]?.total ?? 0,
    isLoading: q.isLoading,
    hasMore: !!q.hasNextPage,
    loadingMore: q.isFetchingNextPage,
    more: () => q.fetchNextPage(),
  };
};


export const useJobsOn = () => {
  const { data } = useApi("settings", "/settings");
  return !data?.jobs_off;
};
